import Modal from "react-modal";
import {Box, Close, Flex, Heading, Image, Link} from "theme-ui";
import {theme as appTheme} from 'app/theme';
import {useTranslation} from "react-i18next";
import {Button, Markdown} from "~/Common";
import {useResponsiveValue} from "@theme-ui/match-media";


export const TigerBrokersModal = ({isOpen, handleClose, ...props}) => {
        const {t} = useTranslation();
        const isVertMobile = useResponsiveValue([true, true, true, false, false, false]);

        const modalClose = () => {
            handleClose();
        };

    const markdownText = `
**As Strategic Partners**  
**Elevate Your Trading with**  
**Next Level Market Access**  

Liquidity Clients' Special:  
✔️ Guaranteed allocation in Liquidity led IPOs  
✔️ Unlock $0 brokerage fees*  
✔️ Unlock $0 currency exchange fees^  
✔️ Deposit any amount automatically to receive AUD 20 Cash Voucher**  
✔️ Deposit over 50K to become a prime client to receive USD 60 Tesla Shares**  

Sign-up with **Tiger Trade APP**  
**Enter the invitation code:** LIQUIDITY  
**For Smarter, Faster Trades**
    `.trim();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={modalClose}
            style={{
                ...appTheme.modals.default,
                content: {
                    ...appTheme.modals.default.content,
                    padding: '0px 20px 0px 0px',
                    textAlign: 'left',
                    maxWidth: '1050px',
                },
            }}
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={300}
            contentLabel="Identity verification"
            aria={{
                labelledby: "verifyHeading"
            }}
            {...props}
        >
            <Close ml="auto" mr={-2} onClick={modalClose} sx={{
                position: 'absolute',
                right: '30px',
                top: '20px',
                zIndex: 101
            }}/>
            {isVertMobile && (
                <Flex sx={{justifyContent: 'center', mb: 3, width: '100%', position: 'absolute', height: '100%', top: 0, left: 0}}>
                    <Image src="/img/tiger-brokers.png"></Image>
                </Flex>
            )}
            <Box sx={{height: '100%'}}>
                <Flex sx={{
                    flexDirection: 'row',
                    gap: '20px',
                    height: '100%',
                }}>
                    {!isVertMobile && (
                        <Flex sx={{flex: 8}}>
                            <Image src="/img/tiger-brokers.png"></Image>
                        </Flex>
                    )}
                    <Flex sx={{
                        position: 'relative',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        flexGrow: 1,
                        flex: 12,
                        paddingY: '40px',
                        paddingX: '20px',
                    }} pl={isVertMobile ? 3 : 0}>
                        {!isVertMobile && (
                            <Box mt={3}
                                mb={3}
                                sx={{
                                    textAlign: 'left',
                            }}>
                                <Heading as="h3" variant="h3">
                                    {t('Tiger Brokers & LIQUIDITY')}
                                </Heading>
                            </Box>
                        )}

                        <Markdown sx={{
                            marginTop: isVertMobile ? 4 : 0,
                            overflowY: 'auto',
                            maxHeight: ['80vh', '80vh'],
                            '& p': {
                                lineHeight: '28px',
                                letterSpacing: '-0.01em',
                                textAlign: 'left',
                                fontSize: '14px',
                            },
                        }}>
                            {t(markdownText)}
                        </Markdown>

                        <Box mt={4}>
                            <Flex mb={0} sx={{flexDirection: ['column', 'row'], justifyContent: 'center'}}>
                                <Flex sx={{flex: 3}}>
                                    <Button
                                        sx={{
                                            width: ['100%', '247px'],
                                            mr: 3,
                                            ml: 0,
                                            mb: [2, 0],
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                        onClick={() => {window.location.href = 'https://www.itiger.com/au/marketing/liquidity?lang=en_US'}}
                                    >
                                        {t('Sign Up')}
                                    </Button>
                                    <Link sx={{
                                        lineHeight: 2.5,
                                        fontWeight: 400,
                                        display: ['block', 'inline'],
                                        textAlign: ['center', 'left']
                                    }} onClick={modalClose}>{t('No thanks')}</Link>
                                </Flex>
                            </Flex>
                        </Box>
                    </Flex>
                </Flex>
            </Box>
        </Modal>
    )
};
